import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const TbLessOrEqualsToIcon = () => {
    return (
        <SvgIcon>
            <polygon points="10.89 7.1 9.85 6.06 4.94 10.96 4.94 10.96 3.89 12 9.81 17.94 10.85 16.91 5.98 12.01 10.89 7.1" />
            <path d="M20,9.74H11v1.47h9Zm-8.92,4.41h9V12.67h-9Z" />
        </SvgIcon>
    );
};
